export default "__VITE_ASSET__CktmgfAf__"